/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {hasInvestingHoldings} from '../api'

export const useMutationHasInvestingHoldings = createReactQueryMutationHook('hasInvestingHoldings', hasInvestingHoldings)
